import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col  } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';

// import Feature0 from './Feature0';
import Feature2 from './Feature2';
import Feature1 from './Feature1';
import Feature5 from './Feature5';
import Teams4 from './Teams4';
import Feature4 from './Feature4';

import Fuwujg from "./fuwujg"
import Gongshirongri from "./gongshirongri"
import Qiyewenhua from "./qiyewenhua"

import {
  Banner20DataSource,
  Feature70DataSource,
  Feature00DataSource,
  Feature20DataSource,
  Feature10DataSource,
  Feature21DataSource,
  Teams40DataSource,
  Feature01DataSource,
  Feature40DataSource,
} from './data.source';

import { Tabs,Icon } from 'antd';
const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

let isMobile;
// enquireScreen((b) => {
//   isMobile = b;
// });

const { location = {} } = typeof window !== 'undefined' ? window : {};


class Content extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    // enquireScreen((b) => {
    //   this.setState({ isMobile: !!b });
    // });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const { dataSource, isMobile, ...props } = this.props;
    const {
      wrapper,
      titleWrapper,
      page,
      OverPack: overPackData,
      childWrapper,
    } = dataSource;

    const children1 = [
      <Feature2
        id="Feature2_0"
        key="Feature2_0"
        dataSource={Feature20DataSource}
        isMobile={this.state.isMobile}
      />,
      <Feature1
        id="Feature1_0"
        key="Feature1_0"
        dataSource={Feature10DataSource}
        isMobile={this.state.isMobile}
      />,
      <Feature2
        id="Feature2_1"
        key="Feature2_1"
        dataSource={Feature21DataSource}
        isMobile={this.state.isMobile}
      />,
    //  <Fuwujg />   
      // <Feature5
      //   id="Feature4_0"
      //   key="Feature4_0"
      //   dataSource={Feature01DataSource}
      //   isMobile={this.state.isMobile}
      // />,
     
    ]
    
    const children2 = [
      <Qiyewenhua />
    ]
    const children3 = [
      <Feature4  dataSource={Feature40DataSource}/>
    ]

    const children4 = [
      <Gongshirongri />
    ]

    
    return (
      <div {...props} {...wrapper}>
        <div {...page}>
          <div {...titleWrapper}>
            {titleWrapper.children.map(getChildrenToRender)}
          </div>
          <OverPack {...overPackData}>
            <QueueAnim
              type="bottom"
              key="block"
              leaveReverse
              component={Row}
              componentProps={childWrapper}
            >
              {childWrapper.children.map((block, i) => {
                const { children: item, ...blockProps } = block;
                return (
                  <Col key={i.toString()} {...blockProps}>
                    <div {...item}>
                      {item.children.map(getChildrenToRender)}
                    </div>
                  </Col>
                );
              })}
            </QueueAnim>
          </OverPack>
          <Tabs defaultActiveKey="1"  onChange={callback}>
            <TabPane icon  
             tab={
              <span>
               <Icon type="read" />
                关于融云
              </span>
            }
            key="1">
             {children1}
            </TabPane>
            <TabPane tab={
              <span>
               <Icon type="instagram" />
                企业文化
              </span>
            } key="2">
             {children2}
            </TabPane>
            <TabPane 
              tab={
              <span>
                <Icon type="fund" />
               企业价值与目标
              </span>
            }
             key="3">
              {children3} 
            </TabPane>
            <TabPane 
              tab={
              <span>
               <Icon type="trophy" />
               公司荣誉
              </span>
            }
            key="4">
              {children4}
            </TabPane>
          </Tabs>
        </div>
        
      </div>
    );
  }
}

export default Content;
